@if (viewType !== 'table') {
  <div
    id="tx-history"
    class="section widget-padding element-zoom h-100 pointer-events-none"
    [ngStyle]="contentStyle"
  >
    <div class="container-fluid h-100">
      <div class="mx-0 h-100">
        @if (filtersEnabled && filterOptions.length > 0) {
          <finxone-web-frontend-filter-container
            [currentTransactionType]="currentTransactionType"
            [isCardTransactions]="isCardTransactions"
            [filterOptions]="filterOptions"
            [filtersEnabled]="filtersEnabled"
            [filterMarginStyle]="filterMarginStyle"
            [attri]="attri"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo"
            (filterChange)="onFilterChange($event)"
            (dateRangeChange)="onDateRangeChange($event)"
            (statusSelectionChange)="onStatusChange($event)"
            (typeSelectionChange)="onTransactionTypeChange($event)"
          ></finxone-web-frontend-filter-container>
        }
        <div
          class="transaction-header d-flex ac-center wrap"
          [ngStyle]="{ 'justify-content': headerAlignment }"
        >
          <div
            *ngIf="renderedTitleTemplate && renderedTitleTemplate.length > 0"
            class="is-left ac-center wrap transaction-title text-center"
            [innerHTML]="renderedTitleTemplate | safeHtml"
          ></div>

          <container-element
            *ngIf="topRightOption !== TransactionHistoryTopRightOption.HIDE"
            [ngSwitch]="this.topRightOption"
          >
            <div
              *ngSwitchCase="TransactionHistoryTopRightOption.QUICK_LINK"
              (click)="navigate()"
              [innerHTML]="renderedQuickLinkTemplate | safeHtml"
            ></div>
            <div class="transaction-tabs" *ngSwitchDefault>
              <form [formGroup]="transactionTypeForm" [ngStyle]="nestedButtonContentStyle">
                <div hlmButtonGroup>
                  @for (option of transactionOptions; track option.value) {
                    <button
                      type="button"
                      class="tab-button"
                      [ngStyle]="nestedButtonContentStyleBorder"
                      [class.active]="transactionTypeForm.get('transactionType')?.value === option.value"
                      (click)="selectTransactionType(option)"
                    >
                      <span class="p-button-label">{{ option.label }}</span>
                    </button>
                  }
                </div>
              </form>
            </div>
          </container-element>
        </div>

        <div class="row mx-0 w-100 recent-transaction-history" [ngStyle]="nestedListStyle">
          <finxone-web-frontend-cancel-payment-template
            [cancelPaymentTemplate]="attri?.['cancelPaymentTemplate']"
          ></finxone-web-frontend-cancel-payment-template>
          <finxone-web-frontend-transaction-history
            *ngIf="
              transactionData.length > 0 && !appBuilderShowNoRecordsContent && !appBuilderShowFetchingContent
            "
            class="w-100"
            [transactionData]="transactionData"
            [imageEnabled]="this.transactionHistoryImageEnabled"
            [transactionTemplate]="this.transactionHistoryItemTemplate"
            (scrolled)="handleChildScroll()"
            [symbolCreditDebitMargin]="this.imageCssProps"
            [enableClickableRow]="enableClickableRow"
            (handleTransactionRowClick)="onClickTransactionRow($event)"
            (handleActionClick)="onClickAction($event)"
            [widgetAttributes]="attri"
          ></finxone-web-frontend-transaction-history>

          @if (
            (isApiInProgress && !cacheIsEmpty && (!transactionData.length || transactionData.length <= 0)) ||
            appBuilderShowFetchingContent
          ) {
            @if (fetchingContent) {
              <div class="w-100" [innerHTML]="fetchingContent | safeHtml"></div>
            } @else {
              <div class="row mx-0 w-100">
                <div class="col-12">
                  <span class="loader-text">Fetching your transactions...</span>
                </div>
              </div>
            }
          } @else {
            @if (noRecordsContent) {
              <div
                class="w-100"
                *ngIf="(!transactionData.length && pageNumber === 1) || appBuilderShowNoRecordsContent"
                [innerHTML]="noRecordsContent | safeHtml"
              ></div>
            } @else {
              <div
                class="row mx-0 w-100"
                *ngIf="(!transactionData.length && pageNumber === 1) || appBuilderShowNoRecordsContent"
              >
                <div class="col-12">
                  <span class="loader-text">No records found</span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <finxone-web-frontend-cancel-payment-template
    [cancelPaymentTemplate]="attri?.['cancelPaymentTemplate']"
  ></finxone-web-frontend-cancel-payment-template>
  <finxone-web-frontend-desktop-listing
    [entityData]="listingEntityData"
    [dataIn]="dataIn"
    [pageNumber]="pageNumber"
    [totalListCount]="totalItems"
    (pageChange)="onPageChange($event)"
    [fetchingContent]="fetchingContent"
    [isApiInProgress]="listingApiInProgress"
    [actionOptions]="actionOptions"
    [enableClickableRow]="enableClickableRow"
    [menuPopupCss]="menuPopupCss"
    [dropdownOptions]="transactionOptions"
    [selectedOption]="selectedOption"
    (dropDownValue)="onChangeTransactionType($event)"
    (rowData)="onClickTransactionRow($event)"
    (performAction)="performAction($event)"
    (actionEvent)="handleAction($event)"
    (searchValueText)="searchValue($event)"
    [totalListDisabled]="totalListDisabled"
  ></finxone-web-frontend-desktop-listing>
}
